import { useState, useEffect } from 'react';

// Hook personalizado para manejar el estado del juego con persistencia
const useGameState = () => {
  // Inicializar estados desde localStorage o valores por defecto
  const [selectedLanguage, setSelectedLanguage] = useState(() => {
    const saved = localStorage.getItem('greenscape_language');
    return saved ? JSON.parse(saved) : null;
  });

  const [selectedCharacters, setSelectedCharacters] = useState(() => {
    const saved = localStorage.getItem('greenscape_characters');
    return saved ? JSON.parse(saved) : null;
  });

  const [gameProgress, setGameProgress] = useState(() => {
    const saved = localStorage.getItem('greenscape_progress');
    if (saved) {
      const progress = JSON.parse(saved);
      // Migración: convertir nombres viejos con doble "m" a nombres con una "m"
      if (progress.completedScreens) {
        progress.completedScreens = progress.completedScreens.map(screen => {
          if (screen === 'dilemma-risk-selection') return 'dilema-risk-selection';
          if (screen === 'dilemma-game') return 'dilema-game';
          return screen;
        });
        console.log('[Migration] Updated screen names:', progress.completedScreens);
      }
      return progress;
    }
    return {
      currentScreen: 'landing',
      completedScreens: []
    };
  });

  // Guardar en localStorage cuando cambian los estados
  useEffect(() => {
    if (selectedLanguage) {
      localStorage.setItem('greenscape_language', JSON.stringify(selectedLanguage));
    }
  }, [selectedLanguage]);

  useEffect(() => {
    if (selectedCharacters) {
      localStorage.setItem('greenscape_characters', JSON.stringify(selectedCharacters));
    }
  }, [selectedCharacters]);

  useEffect(() => {
    localStorage.setItem('greenscape_progress', JSON.stringify(gameProgress));
  }, [gameProgress]);

  // Función para actualizar el progreso
  const updateProgress = (screen) => {
    console.log(`[updateProgress] Updating progress for screen: ${screen}`);
    
    setGameProgress(prev => {
      console.log(`[updateProgress] Previous progress:`, prev);
      
      const newProgress = {
        currentScreen: screen,
        completedScreens: [...new Set([...prev.completedScreens, screen])]
      };
      
      console.log(`[updateProgress] New progress:`, newProgress);
      
      // Actualizar localStorage inmediatamente para que las rutas protegidas funcionen
      localStorage.setItem('greenscape_progress', JSON.stringify(newProgress));
      console.log(`[updateProgress] Saved to localStorage`);
      
      // Verificar que se guardó
      const saved = JSON.parse(localStorage.getItem('greenscape_progress'));
      console.log(`[updateProgress] Verified saved progress:`, saved);
      
      return newProgress;
    });
  };

  // Función para resetear todo el juego
  const resetGame = () => {
    localStorage.removeItem('greenscape_language');
    localStorage.removeItem('greenscape_characters');
    localStorage.removeItem('greenscape_progress');
    setSelectedLanguage(null);
    setSelectedCharacters(null);
    setGameProgress({
      currentScreen: 'landing',
      completedScreens: []
    });
  };

  // Verificar si una pantalla está disponible
  const canAccessScreen = (screen) => {
    const requiredScreens = {
      'landing': [],
      'language': [],
      'intro': ['language'],
      'character-selection': ['language', 'intro'],
      'player-data-form': ['language', 'intro', 'character-selection'],
      'awareness': ['language', 'intro', 'character-selection', 'player-data-form'],
      'game': ['language', 'intro', 'character-selection', 'player-data-form', 'awareness'],
      'awareness-wrapup': ['language', 'intro', 'character-selection', 'player-data-form', 'awareness', 'game'],
      'awareness-reflection': ['language', 'intro', 'character-selection', 'player-data-form', 'awareness', 'game', 'awareness-wrapup'],
      'dilema-risk-selection': ['language', 'intro', 'character-selection', 'player-data-form', 'awareness', 'game', 'awareness-wrapup', 'awareness-reflection'],
      'dilemma-reflection': ['language', 'intro', 'character-selection', 'player-data-form', 'awareness', 'game', 'awareness-wrapup', 'awareness-reflection', 'dilema-risk-selection', 'dilema-game']
    };

    const required = requiredScreens[screen] || [];
    
    // Leer directamente desde localStorage para obtener el estado más actualizado
    const currentProgress = JSON.parse(localStorage.getItem('greenscape_progress') || '{"completedScreens":[]}');
    const completed = currentProgress.completedScreens || [];
    
    console.log(`[canAccessScreen] Checking access to: ${screen}`);
    console.log(`[canAccessScreen] Required screens:`, required);
    console.log(`[canAccessScreen] Completed screens:`, completed);
    
    const hasAccess = required.every(s => completed.includes(s));
    console.log(`[canAccessScreen] Access granted:`, hasAccess);
    
    return hasAccess;
  };

  return {
    selectedLanguage,
    setSelectedLanguage,
    selectedCharacters,
    setSelectedCharacters,
    gameProgress,
    updateProgress,
    resetGame,
    canAccessScreen
  };
};

export default useGameState;

